import { Attributes, List, Model, ModelBase, Validation, Rules } from '@singularsystems/neo-core';
import { QuestionType } from '../../Enums/QuestionType';
import DropDownItem from '../DropDownItem';
import QuestionConfig from '../Config/QuestionConfig';

export default class QuestionnaireQuestionAnswerDetail extends ModelBase {
    static typeName = "QuestionnaireQuestionAnswerDetail";

    constructor() {
        super();
        this.makeObservable();
    }

    public questionnaireQuestionAnswerId: number = 0;

    public questionnaireAnsweredId: number = 0;

    public questionnaireQuestionId: number = 0;

    public question: string = "";

    @Rules.StringLength(4000)
    public questionAnswer: string = "";

    @Attributes.OnChanged<QuestionnaireQuestionAnswerDetail>(c => c.onItemDisplayChanged)
    public questionAnswerDropDownValue: string = "";

    public questionAnswerMultiSelectDropDownValues: string[] = [];

    public questionInfoText: string = "";

    public answerPlaceholder: string = "";

    public questionType: QuestionType | null = null;

    @Attributes.Integer()
    public questionOrder: number = 0;

    @Attributes.Display("Required")
    public isRequired: boolean = false;

    public dropDownItems = new List(DropDownItem);

    @Attributes.ChildObject(QuestionConfig, true)
    public config: QuestionConfig | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public selectedDropDownItems: Model.ISelectedItem[] = [];

    public async onItemDisplayChanged() {
        const item = this.dropDownItems.find(i => i.itemValue === this.questionAnswerDropDownValue);
        this.questionAnswer = item!.itemDisplay;
    }

    protected addBusinessRules(rules: Validation.Rules<this>) {
        rules.failWhen(c => c.isRequired === true
            && !c.questionAnswer && c.questionType !== QuestionType.DropDown && c.questionType !== QuestionType.MultiSelectDropDown,
            "Answer must be specified.")
            .onProperties(c => c.questionAnswer);

        rules.failWhen(c => c.isRequired === true
            && !c.questionAnswerDropDownValue && c.questionType === QuestionType.DropDown,
            "Please select an answer.")
            .onProperties(c => c.questionAnswerDropDownValue);

      rules.failWhen(c => c.questionType == QuestionType.MultiSelectDropDown &&
                           c.isRequired && c.questionAnswerMultiSelectDropDownValues.length === 0,
                           "At least 1 answer must be selected")
                    .onProperties(c => c.questionAnswerMultiSelectDropDownValues);
      rules.failWhen(c => c.questionType == QuestionType.MultiSelectDropDown &&
                           c.isRequired &&
                           c.config != null && c.config.multiSelectDropDown != null &&
                           c.config.multiSelectDropDown.minSelectedItems > c.questionAnswerMultiSelectDropDownValues.length &&
                           c.config.multiSelectDropDown.minSelectedItems > 1,
                           c => `At least ${c.config!.multiSelectDropDown!.minSelectedItems} answers must be selected`)
                    .onProperties(c => c.questionAnswerMultiSelectDropDownValues);
      rules.failWhen(c => c.questionType == QuestionType.MultiSelectDropDown &&
                           c.config != null && c.config.multiSelectDropDown != null &&
                           (c.config.multiSelectDropDown.maxSelectedItems ?? 1000) < c.questionAnswerMultiSelectDropDownValues.length,
                           c => `A maximum of ${c.config!.multiSelectDropDown!.maxSelectedItems} answers may be selected`)
                    .onProperties(c => c.questionAnswerMultiSelectDropDownValues);
    }
}